/* ARCANIS · Mirror + Leather · behaviours (vanilla, no dependency) */
(function () {
  const I18N = Object.assign({ unavailable: 'Unavailable', on_request: 'On request', limited_to: 'Limited to %n', complete: 'Complete · %n', eta: 'Estimated delivery', eta_to: 'to', cart: 'Cart' }, window.arcI18n || {});
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header + menu ---------- */
  function initHeader() {
    const header = $('.arc-header');
    if (!header) return;
    const menu = $('.arc-menu');
    const burger = $('.arc-burger', header);
    if (burger && menu) {
      burger.addEventListener('click', () => {
        const open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        header.classList.toggle('menu-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
    }
    if (header.classList.contains('arc-header--overlay')) {
      const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 40);
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
    const cart = $('.arc-cart', header);
    if (cart) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => {
        cart.dataset.count = c.item_count; const cc = cart.querySelector('[data-arc-cart-count]'); if (cc) cc.textContent = c.item_count; else cart.textContent = I18N.cart + ' · ' + c.item_count;
      }).catch(() => {});
    }
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    const els = $$('.arc-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(e => io.observe(e));
  }

  /* ---------- money ---------- */
  function money(cents, currency, format) {
    // Same output as Liquid money_without_trailing_zeros, from the shop money format
    if (format && /\{\{\s*\w+\s*\}\}/.test(format)) {
      const key = format.match(/\{\{\s*(\w+)\s*\}\}/)[1];
      const n = cents / 100;
      const fixed = (dec, thou, decsep) => {
        const parts = Math.abs(n).toFixed(dec).split('.');
        const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return (n < 0 ? '-' : '') + (parts[1] ? int + decsep + parts[1] : int);
      };
      const table = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_apostrophe_separator: [0, "'", '.'],
        amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.']
      };
      const t = table[key] || table.amount;
      const s = fixed(t[0], t[1], t[2]).replace(/([.,])00$/, '');
      return format.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '').trim();
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0) + ' ' + (currency || ''); }
  }

  /* ---------- delivery estimate: business days from today, as dates ---------- */
  function etaText(min, max) {
    const add = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; };
    const a = add(min), b = add(max);
    const lang = document.documentElement.lang || 'en';
    const full = (d) => new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }).format(d);
    const month = (d) => new Intl.DateTimeFormat(lang, { month: 'long' }).format(d);
    const same = a.getMonth() === b.getMonth();
    if (!same) return I18N.eta + ' ' + full(a) + ' ' + I18N.eta_to + ' ' + full(b);
    return I18N.eta + ' ' + (lang.indexOf('en') === 0 ? month(a) + ' ' + a.getDate() + ' ' + I18N.eta_to + ' ' + b.getDate() : a.getDate() + ' ' + I18N.eta_to + ' ' + b.getDate() + ' ' + month(a));
  }
  function initEta(scope) {
    $$('[data-arc-eta]', scope || document).forEach(e => {
      const min = Number(e.dataset.arcMin || 8), max = Number(e.dataset.arcMax || 15);
      try { e.textContent = etaText(min, max); } catch (err) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initEta()); else initEta();

  /* ---------- cart drawer and cart page ---------- */
  function initCart() {
    const roots = $$('[data-arc-cart-root]');
    if (!roots.length) return;
    const drawer = $('[data-arc-drawer]');
    const setCount = (n) => { $$('[data-arc-cart-count]').forEach(e => e.textContent = n); $$('.arc-cart').forEach(a => a.dataset.count = n); };
    async function refresh(root) {
      const id = root.dataset.arcSection; if (!id) return;
      try {
        const html = await fetch('/cart?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } }).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nl = doc.querySelector('[data-arc-cart-lines]'), nf = doc.querySelector('[data-arc-cart-foot]'), nc = doc.querySelector('[data-arc-cart-count]');
        const ol = root.querySelector('[data-arc-cart-lines]'), of = root.querySelector('[data-arc-cart-foot]');
        if (nl && ol) ol.innerHTML = nl.innerHTML;
        if (nf && of) of.innerHTML = nf.innerHTML;
        if (nc) setCount(nc.textContent.trim());
        initEta(root);
        // the protection alone makes no sense: drop it when the last piece is gone
        const lone = root.querySelector('[data-arc-only-protection]');
        if (lone && !root.dataset.arcCleaning) {
          root.dataset.arcCleaning = '1';
          try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: lone.dataset.arcOnlyProtection, quantity: 0 }) }); } catch (err) {}
          await refresh(root);
          delete root.dataset.arcCleaning;
        }
      } catch (e) {}
    }
    roots.forEach(root => {
      // extra protection toggle
      root.addEventListener('change', async (e) => {
        const up = e.target.closest('[data-arc-upsell]'); if (!up) return;
        const row = up.closest('.arc-upsell'); if (row) row.classList.add('is-busy');
        try {
          if (up.checked) await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(up.dataset.arcUpsell), quantity: 1 }] }) });
          else if (up.dataset.arcUpsellKey) await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: up.dataset.arcUpsellKey, quantity: 0 }) });
        } catch (err) {}
        await refresh(root);
      });
      root.addEventListener('click', async (e) => {
        const add = e.target.closest('[data-arc-add-variant]');
        if (add) {
          add.classList.add('is-busy'); add.disabled = true;
          try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.dataset.arcAddVariant), quantity: 1 }] }) }); } catch (err) {}
          await refresh(root);
          return;
        }
        const step = e.target.closest('[data-arc-step]'); const rm = e.target.closest('[data-arc-remove]');
        if (!step && !rm) return;
        const line = e.target.closest('[data-arc-line]'); if (!line) return;
        const qty = rm ? 0 : Math.max(0, Number(line.dataset.arcQty) + Number(step.dataset.arcStep));
        line.classList.add('is-busy');
        try {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.arcLine, quantity: qty }) });
        } catch (err) {}
        await refresh(root);
      });
    });
    if (!drawer) return;
    let arcFocusReturn = null;
    const open = () => {
      refresh(drawer); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('arc-lock');
      arcFocusReturn = document.activeElement;
      const c = drawer.querySelector('[data-arc-drawer-close]:not(.arc-drawer__backdrop)'); if (c) setTimeout(() => c.focus(), 350);
    };
    const close = () => {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('arc-lock');
      if (arcFocusReturn && arcFocusReturn.focus) { try { arcFocusReturn.focus(); } catch (e) {} }
    };
    // keep the tab key inside the open drawer
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const f = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    $$('.arc-cart').forEach(a => a.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('[data-arc-drawer-close]', drawer).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    window.arcOpenCart = open;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart); else initCart();

  /* ---------- product ---------- */
  function initProduct(root) {
    const dataEl = $('[data-arc-product-json]', root);
    if (!dataEl) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const form = $('form[data-arc-form]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const optionsCount = data.options.length;
    const selected = data.selected.slice();
    const onRequestAbove = data.on_request_above || 1000000;
    let lastMedia = null;

    function findVariant() {
      return data.variants.find(v => v.options.every((o, i) => o === selected[i]));
    }
    function updateOptionUI() {
      $$('[data-arc-option]', root).forEach(el => {
        const i = Number(el.dataset.arcOption); const val = el.dataset.value;
        el.classList.toggle('is-active', selected[i] === val);
        // availability: is there an available variant with this value and the other selected values?
        const ok = data.variants.some(v => v.available && v.options[i] === val && v.options.every((o, j) => j === i || o === selected[j]));
        el.classList.toggle('is-unavailable', !ok);
      });
      $$('[data-arc-option-name]', root).forEach(el => { const i = Number(el.dataset.arcOptionName); el.textContent = selected[i]; });
    }
    function render(initial) {
      const v = findVariant();
      updateOptionUI();
      const priceEls = $$('[data-arc-price]', root);
      const buyEls = $$('[data-arc-buy-zone]', root);
      const reqEls = $$('[data-arc-request-zone]', root);
      if (!v) {
        priceEls.forEach(e => e.textContent = I18N.unavailable);
        buyEls.forEach(e => e.classList.add('arc-hidden'));
        return;
      }
      if (idInput) idInput.value = v.id;
      const onRequest = data.price_on_request || v.price > onRequestAbove;
      priceEls.forEach(e => e.textContent = onRequest ? I18N.on_request : money(v.price, data.currency, data.money_format));
      buyEls.forEach(e => e.classList.toggle('arc-hidden', onRequest || !v.available));
      reqEls.forEach(e => e.classList.toggle('arc-hidden', false));
      $$('[data-arc-soldout]', root).forEach(e => e.classList.toggle('arc-hidden', v.available));
      // edition counter
      // edition size: variant metafield, else "Edition of N" in the size name, else the product value
      let ed = v.edition || 0;
      if (!ed) { const m = /edition\s+of\s+(\d+)/i.exec((v.options || []).join(' ')); if (m) ed = Number(m[1]); }
      if (!ed) ed = data.edition || 0;
      const inv = (typeof v.inventory === 'number') ? v.inventory : null;
      let sold = null;
      if (ed > 0 && inv !== null) sold = Math.max(0, Math.min(ed, ed - inv));
      $$('[data-arc-edition]', root).forEach(e => e.textContent = ed > 0 ? ed : '—');
      $$('[data-arc-sold]', root).forEach(e => e.textContent = sold !== null ? sold : '—');
      // the big counter only once at least one piece is gone: never a fake number, never a zero
      $$('[data-arc-counter]', root).forEach(e => e.classList.toggle('arc-hidden', sold === null || sold <= 0 || ed <= 0));
      $$('[data-arc-edition-row]', root).forEach(e => e.classList.toggle('arc-hidden', ed <= 0));
      $$('[data-arc-edition-line]', root).forEach(e => e.textContent = ed <= 0 ? '' : ((sold !== null && sold >= ed) ? I18N.complete.replace('%n', ed) : I18N.limited_to.replace('%n', ed)));
      // sizes on the wall
      const si = (data.options || []).findIndex(o => /size|taille|format|dimension/i.test(String(o)));
      if (si >= 0) { const sv = selected[si]; $$('[data-arc-size]', root).forEach(el => el.classList.toggle('is-active', el.dataset.arcSize === sv)); }
      // media per variant: only when the chosen variant carries its own image
      if (!initial && v.featured_media && v.featured_media !== lastMedia && $('[data-arc-media-id="' + v.featured_media + '"]', root)) showMedia(root, v.featured_media);
      lastMedia = v.featured_media;
      // url
      try { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      // sticky
      $$('[data-arc-sticky-price]').forEach(e => e.textContent = onRequest ? I18N.on_request : money(v.price, data.currency, data.money_format));
      $$('[data-arc-sticky-variant]').forEach(e => { const t = (v.options || []).filter(o => o && o !== 'Default Title').join(' · ').replace(/\s*\|\s*/g, ' · '); e.textContent = t ? t + ' · ' : ''; });
    }
    $$('[data-arc-option]', root).forEach(el => el.addEventListener('click', (ev) => {
      ev.preventDefault(); selected[Number(el.dataset.arcOption)] = el.dataset.value; render();
    }));
    // buy now → cart/add then checkout
    async function addToCart(redirect) {
      if (!form) return;
      const btns = $$('[data-arc-buy],[data-arc-add]', root); btns.forEach(b => b.classList.add('is-busy'));
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('add failed');
        window.location.href = redirect;
      } catch (e) {
        btns.forEach(b => b.classList.remove('is-busy'));
        form.submit();
      }
    }
    $$('[data-arc-buy]', root).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart('/checkout'); }));
    $$('[data-arc-add]', root).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart('/cart'); }));
    // thumbnails
    $$('[data-arc-thumb]', root).forEach(t => t.addEventListener('click', () => showMedia(root, t.dataset.arcThumb)));
    // sticky bar
    const hud = $('[data-arc-hud]', root); const sticky = $('.arc-sticky');
    if (hud && sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { sticky.classList.toggle('is-visible', !en[0].isIntersecting); }, { threshold: 0.05 });
      io.observe(hud);
      $$('[data-arc-buy]', sticky).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart('/checkout'); }));
    }
    render(true);
    syncHint(root);
    fitTitles();
    // product videos: buffer once the page is idle, play ring if autoplay is refused
    $$('[data-arc-media-type="video"]', root).forEach(m => {
      const vid = $('video', m); if (!vid) return;
      m.style.position = 'relative';
      if (!m.querySelector('.arc-video-play')) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'arc-video-play'; b.setAttribute('aria-label', 'Play'); b.innerHTML = '<span></span>';
        b.addEventListener('click', () => { vid.muted = true; vid.play().then(() => m.classList.remove('needs-tap')).catch(() => {}); });
        m.appendChild(b);
      }
      vid.addEventListener('error', () => m.classList.add('needs-tap'));
      // nothing is fetched until the visitor opens this media (showMedia loads and plays it)
      try { vid.preload = 'none'; vid.removeAttribute('autoplay'); } catch (e) {}
    });
  }
  function syncHint(root) {
    const active = $$('[data-arc-media-id]', root).find(m => !m.classList.contains('arc-hidden'));
    const rotatable = !!(active && active.dataset.arcMediaType === 'model') || !!$('.arc-spin', root);
    $$('.arc-hint, [data-arc-orbit]', root).forEach(h => h.classList.toggle('arc-hidden', !rotatable));
  }
  function showMedia(root, id) {
    $$('[data-arc-media-id]', root).forEach(m => {
      const on = m.dataset.arcMediaId === String(id);
      m.classList.toggle('arc-hidden', !on);
      const vid = m.tagName === 'VIDEO' ? m : $('video', m);
      if (vid) {
        if (on) {
          vid.muted = true; vid.setAttribute('playsinline', '');
          if (vid.preload !== 'auto') { vid.preload = 'auto'; try { vid.load(); } catch (e) {} }
          const p = vid.play();
          if (p && p.catch) p.then(() => m.classList.remove('needs-tap')).catch(() => m.classList.add('needs-tap'));
        } else { vid.pause(); }
      }
    });
    $$('[data-arc-thumb]', root).forEach(t => t.classList.toggle('is-active', t.dataset.arcThumb === String(id)));
    syncHint(root);
  }

  /* ---------- spin viewer (photo 360) ---------- */
  function initSpin(el) {
    const imgs = $$('img', el); if (imgs.length < 2) return;
    let i = 0, dragging = false, startX = 0, startI = 0, idle = null;
    const show = (n) => { i = ((n % imgs.length) + imgs.length) % imgs.length; imgs.forEach((im, k) => im.classList.toggle('is-current', k === i)); };
    show(0);
    const perFrame = Math.max(3, Math.round(el.clientWidth / imgs.length));
    el.addEventListener('pointerdown', (e) => { dragging = true; startX = e.clientX; startI = i; el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); clearInterval(idle); });
    el.addEventListener('pointermove', (e) => { if (!dragging) return; show(startI + Math.round((startX - e.clientX) / perFrame)); });
    const stop = () => { dragging = false; el.classList.remove('is-dragging'); };
    el.addEventListener('pointerup', stop); el.addEventListener('pointercancel', stop);
    if (!reduced && el.dataset.autorotate !== 'false') idle = setInterval(() => show(i + 1), 120);
  }

  /* ---------- tilt (3D card for prints) ---------- */
  function initTilt(el) {
    const inner = $('.arc-tilt__inner', el); if (!inner) return;
    let dragging = false, sx = 0, sy = 0, ry = parseFloat(el.dataset.ry || '-16'), rx = parseFloat(el.dataset.rx || '2'), by = ry, bx = rx;
    const set = () => { inner.style.setProperty('--arc-ry', ry + 'deg'); inner.style.setProperty('--arc-rx', rx + 'deg'); };
    set();
    el.addEventListener('pointerdown', (e) => { dragging = true; sx = e.clientX; sy = e.clientY; by = ry; bx = rx; el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); });
    el.addEventListener('pointermove', (e) => {
      if (dragging) { ry = Math.max(-60, Math.min(60, by + (e.clientX - sx) / 4)); rx = Math.max(-25, Math.min(25, bx - (e.clientY - sy) / 6)); set(); }
      else if (!reduced && matchMedia('(hover:hover)').matches) { const r = el.getBoundingClientRect(); ry = -16 + ((e.clientX - r.left) / r.width - .5) * 22; rx = 2 - ((e.clientY - r.top) / r.height - .5) * 12; set(); }
    });
    const stop = () => { dragging = false; el.classList.remove('is-dragging'); };
    el.addEventListener('pointerup', stop); el.addEventListener('pointercancel', stop);
    el.addEventListener('pointerleave', () => { if (!dragging) { ry = parseFloat(el.dataset.ry || '-16'); rx = parseFloat(el.dataset.rx || '2'); set(); } });
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    const t = Date.parse(el.dataset.arcCountdown); if (isNaN(t)) return;
    const d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el);
    const tick = () => {
      let s = Math.max(0, Math.floor((t - Date.now()) / 1000));
      const dd = Math.floor(s / 86400); s -= dd * 86400; const hh = Math.floor(s / 3600); s -= hh * 3600; const mm = Math.floor(s / 60);
      if (d) d.textContent = String(dd).padStart(2, '0'); if (h) h.textContent = String(hh).padStart(2, '0'); if (m) m.textContent = String(mm).padStart(2, '0');
    };
    tick(); setInterval(tick, 30000);
  }

  /* ---------- 3D model materials: the exports carry the art as rough metal, which renders grey ---------- */
  function tuneModel(mv) {
    try {
      const mats = mv.model && mv.model.materials; if (!mats) return;
      if (mv.dataset.arcTuned === '1') return;
      mats.forEach(m => {
        const pbr = m.pbrMetallicRoughness;
        const hasTex = !!(pbr.baseColorTexture && pbr.baseColorTexture.texture);
        const em = m.emissiveFactor || [0, 0, 0];
        const base = pbr.baseColorFactor || [1, 1, 1, 1];
        const name = (m.name || '').toLowerCase();
        if (hasTex && (em[0] > 0.5 || /cylind|sticker|etiquette/.test(name)) && !/cycle/.test(name)) {
          // the edition sticker cylinder: hide it
          try { m.setAlphaMode('BLEND'); } catch (e) {}
          pbr.setBaseColorFactor([0, 0, 0, 0]); m.setEmissiveFactor([0, 0, 0]); pbr.setMetallicFactor(0);
        } else if (hasTex) {
          // the printed art comes out of Blender as rough metal (grey in a viewer): light it from within, softly,
          // keep a glossy layer so the chrome streak still sweeps across it
          try { m.emissiveTexture.setTexture(pbr.baseColorTexture.texture); } catch (e) {}
          m.setEmissiveFactor([0.62, 0.62, 0.62]);
          pbr.setBaseColorFactor([0.28, 0.28, 0.28, 1]);
          pbr.setMetallicFactor(0.12); pbr.setRoughnessFactor(0.3);
        } else if (pbr.metallicFactor > 0.9 && pbr.roughnessFactor < 0.1 && base[0] > 0.5) {
          // the mirror plate
          pbr.setRoughnessFactor(0.06);
        }
      });
      mv.dataset.arcTuned = '1';
    } catch (e) {}
  }

  /* ---------- idle sway: a slow float, never the back of the piece; stops while the visitor drags ---------- */
  function swayModel(mv) {
    let last = 0; const t0 = performance.now();
    mv.addEventListener('camera-change', (e) => { if (e.detail && e.detail.source === 'user-interaction') last = performance.now(); });
    mv.addEventListener('pointerdown', () => { last = performance.now(); });
    function tick(now) {
      if (!document.hidden && now - last > 5000 && !mv.classList.contains('arc-hidden') && !(mv.closest('.arc-hidden'))) {
        const t = (now - t0) / 1000;
        mv.cameraOrbit = (-22 + 9 * Math.sin(t / 3.6)) + 'deg ' + (80 + 2.5 * Math.sin(t / 5.3)) + 'deg ' + (mv.dataset.arcRadius || 82) + '%';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- room videos load only when near, story unfolds on demand ---------- */
  function initLazyMedia() {
    $$('video[data-arc-lazy-video]').forEach(v => {
      const ready = () => v.classList.add('is-ready');
      ['loadeddata', 'canplay', 'playing'].forEach(ev => v.addEventListener(ev, ready, { once: true }));
      setTimeout(ready, 5000);
      const box = v.parentElement;
      const load = () => { if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); } };
      // a play ring when autoplay is refused (low-power mode, data saver)
      const tryPlay = () => v.play().then(() => box.classList.remove('needs-tap')).catch(() => box.classList.add('needs-tap'));
      if (box && !box.querySelector('.arc-video-play')) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'arc-video-play'; b.setAttribute('aria-label', 'Play'); b.innerHTML = '<span></span>';
        b.addEventListener('click', () => { load(); v.muted = true; tryPlay(); });
        box.appendChild(b);
      }
      v.addEventListener('error', () => box && box.classList.add('needs-tap'));
      // load only when the visitor gets near it (a 5 MB clip stays untouched for people who never scroll there)
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en.some(e => e.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '700px 0px' });
        io.observe(v);
      } else load();
      if (!('IntersectionObserver' in window)) { load(); tryPlay(); return; }
      const io = new IntersectionObserver(en => { en.forEach(e => { if (e.isIntersecting) { load(); tryPlay(); } else { v.pause(); } }); }, { rootMargin: '600px 0px' });
      io.observe(v);
    });
    $$('[data-arc-story-toggle]').forEach(b => b.addEventListener('click', () => { const body = b.previousElementSibling; if (body) body.classList.remove('is-collapsed'); b.remove(); }));
    // hotspots: one open at a time, hover on desktop, tap on touch
    $$('[data-arc-hotspots]').forEach(box => {
      const dots = $$('[data-arc-hot]', box);
      const open = (id) => { dots.forEach(d => { const on = d.dataset.arcHot === id; d.classList.toggle('is-open', on); d.setAttribute('aria-expanded', on ? 'true' : 'false'); }); $$('[data-arc-hot-card]', box).forEach(c => c.classList.toggle('is-open', c.dataset.arcHotCard === id)); };
      dots.forEach(d => {
        d.addEventListener('click', (e) => { e.preventDefault(); open(d.classList.contains('is-open') ? null : d.dataset.arcHot); });
        d.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) open(d.dataset.arcHot); });
      });
      box.addEventListener('mouseleave', () => open(null));
      document.addEventListener('click', (e) => { if (!box.contains(e.target)) open(null); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazyMedia); else initLazyMedia();

  /* ---------- colourway thumbnails on cards: hover previews the colour on the card ---------- */
  function initSwatchRows() {
    $$('.arc-swatch-row').forEach(row => {
      const card = row.closest('.arc-print-card'); if (!card) return;
      const main = $('.arc-print-card__main', card); const alt = $('.arc-print-card__alt', card); if (!main) return;
      const original = { src: main.getAttribute('src'), srcset: main.getAttribute('srcset') };
      $$('.arc-swatch-thumb', row).forEach(t => t.addEventListener('mouseenter', () => {
        main.removeAttribute('srcset'); main.src = t.dataset.arcSwatchImg; card.classList.add('is-previewing');
      }));
      row.addEventListener('mouseleave', () => { if (original.srcset) main.setAttribute('srcset', original.srcset); main.src = original.src; card.classList.remove('is-previewing'); });
      if (alt) card.addEventListener('mouseleave', () => card.classList.remove('is-previewing'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSwatchRows); else initSwatchRows();

  /* ---------- modals (size guide) ---------- */
  function initModals() {
    $$('[data-arc-open]').forEach(b => b.addEventListener('click', () => { const d = document.getElementById(b.dataset.arcOpen); if (d && d.showModal && !d.open) d.showModal(); }));
    $$('.arc-modal').forEach(d => {
      d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
      $$('[data-arc-close]', d).forEach(c => c.addEventListener('click', () => d.close()));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initModals); else initModals();

  /* ---------- HUD title: one line, shrink to fit ---------- */
  function fitTitles() {
    $$('.arc-product__title').forEach(el => {
      el.style.fontSize = ''; el.style.whiteSpace = 'nowrap';
      let size = parseFloat(getComputedStyle(el).fontSize) || 32; let guard = 0;
      while (el.scrollWidth > el.clientWidth && size > 16 && guard++ < 40) { size -= 1; el.style.fontSize = size + 'px'; }
      if (el.scrollWidth > el.clientWidth) el.style.whiteSpace = '';
    });
  }
  let fitTimer = null;
  window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitTitles, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);

  /* ---------- home hero: one print of the pool in 3D, never the same as the previous visit ---------- */
  function initHeroPool() {
    const hero = $('[data-arc-hero-pool]'); if (!hero) return;
    const jsonEl = $('[data-arc-hero-json]', hero); const mv = $('[data-arc-hero-model]', hero);
    if (!jsonEl || !mv) return;
    document.documentElement.classList.add('arc-hero3d');
    let pool = []; try { pool = JSON.parse(jsonEl.textContent) || []; } catch (e) { return; }
    if (pool.length < 2) return;
    let last = -1; try { last = parseInt(localStorage.getItem('arc-hero-last') || '-1', 10); } catch (e) {}
    let i = Math.floor(Math.random() * pool.length);
    if (i === last) i = (i + 1 + Math.floor(Math.random() * (pool.length - 1))) % pool.length;
    try { localStorage.setItem('arc-hero-last', String(i)); } catch (e) {}
    const p = pool[i]; if (!p || !p.g) return;
    mv.removeAttribute('src');
    mv.setAttribute('alt', (p.t || '') + ' 3D');
    const photo = $('[data-arc-hero-photo]', hero);
    if (photo && p.i) { photo.src = p.i; photo.alt = p.t || ''; }
    mv.addEventListener('load', () => hero.classList.add('is-3d'), { once: true });
    // the photo is the first paint; the 3D file comes once the page has settled
    const start = () => { const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 300)); idle(() => mv.setAttribute('src', p.g)); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    const set = (sel, txt) => $$(sel, hero).forEach(e => { e.textContent = txt; });
    set('[data-arc-hero-title]', p.t || '');
    set('[data-arc-hero-price]', p.p || '');
    const col = $('[data-arc-hero-colour]', hero);
    if (col) { col.textContent = p.c || ''; const row = col.closest('.arc-row'); if (row) row.hidden = !p.c; }
    $$('[data-arc-hero-link]', hero).forEach(a => { a.href = p.u; });
    // the model-viewer component: Shopify loads it for data-shopify-feature elements; make sure it is there
    setTimeout(() => {
      if (window.customElements && customElements.get('model-viewer')) return;
      const load = () => {
        if (customElements.get('model-viewer')) return;
        const s = document.createElement('script'); s.type = 'module'; s.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.12/model-viewer.min.js'; document.head.appendChild(s);
      };
      if (window.Shopify && window.Shopify.loadFeatures) {
        try { window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: () => {} }]); } catch (e) {}
        setTimeout(load, 2500);
      } else load();
    }, 1500);
  }

  /* ---------- 3D model (Shopify model-viewer UI) ---------- */
  function initModels() {
    const models = $$('.arc-stage model-viewer, .arc-card__media model-viewer');
    if (!models.length || !window.Shopify || !window.Shopify.loadFeatures) return;
    models.forEach(mv => {
      // direct rotation, page still scrolls with one finger, slow idle turn, slightly tilted like the mockup
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('interaction-prompt', 'none');
      mv.removeAttribute('auto-rotate');
      mv.setAttribute('shadow-intensity', '0');
      mv.setAttribute('disable-zoom', '');
      // the auto-generated preview is a white square: show the product photo on black instead while the model loads
      // no poster at all (the photo showed as a grey veil while loading): the model fades in once ready
      mv.removeAttribute('poster');
      const reveal = () => mv.classList.add('is-loaded');
      mv.addEventListener('load', reveal, { once: true });
      setTimeout(reveal, 8000);
      mv.removeAttribute('camera-target');
      mv.removeAttribute('field-of-view');
      const applyOrbit = () => {
        const r = Number(mv.dataset.arcRadius || 82);
        mv.setAttribute('camera-orbit', '-22deg 80deg ' + r + '%');
        mv.setAttribute('min-camera-orbit', 'auto auto ' + Math.round(r * 0.85) + '%');
        mv.setAttribute('max-camera-orbit', 'auto auto ' + Math.round(r * 1.6) + '%');
      };
      applyOrbit();
      // wide formats (panoramic prints) were cut on the sides: step the camera back according to the width/height ratio
      mv.addEventListener('load', () => {
        try {
          const d = mv.getDimensions(); const ratio = d && d.y ? d.x / d.y : 1;
          const r = ratio > 1.6 ? 104 : (ratio > 1.25 ? 94 : (ratio < 0.8 ? 92 : 82));
          if (String(r) !== mv.dataset.arcRadius) { mv.dataset.arcRadius = String(r); applyOrbit(); }
        } catch (e) {}
      });
      // studio strip light for the mirror surfaces (LDR equirect), a bit more exposure to compensate
      const wrap = mv.closest('[data-arc-env]');
      if (wrap && wrap.dataset.arcEnv) { mv.setAttribute('environment-image', wrap.dataset.arcEnv); mv.setAttribute('exposure', '1.35'); }
      mv.addEventListener('load', () => { tuneModel(mv); setTimeout(() => tuneModel(mv), 400); });
      if (mv.loaded) tuneModel(mv);
      swayModel(mv);
    });
    window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {
      models.forEach(mv => {
        try {
          const ui = new window.Shopify.ModelViewerUI(mv, { focusOnPlay: false });
          const play = () => {
            try { if (ui && typeof ui.play === 'function') ui.play(); } catch (e) {}
            const b = mv.parentElement && mv.parentElement.querySelector('.shopify-model-viewer-ui__button--poster');
            if (b) b.click();
            mv.setAttribute('camera-controls', '');
          };
          play(); setTimeout(play, 800); setTimeout(play, 2500);
        } catch (e) {}
      });
    } }]);
  }

  function init() {
    initHeader(); initReveal(); initHeroPool(); initModels();
    $$('[data-arc-product]').forEach(initProduct);
    $$('.arc-spin').forEach(initSpin);
    $$('.arc-tilt').forEach(initTilt);
    $$('[data-arc-countdown]').forEach(initCountdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
